module.exports = __webpack_public_path__ + "img/community_development.f5939f87.svg";